import { api } from "@/lib/api";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH.
// redirect_uri is built from window.location.origin so it works on preview, prod & custom domain.

let cachedClientId = null;

async function getClientId() {
  if (cachedClientId) return cachedClientId;
  const { data } = await api.get("/auth/google/config");
  if (!data?.configured || !data?.client_id) {
    throw new Error("Google OAuth non configurato sul server.");
  }
  cachedClientId = data.client_id;
  return cachedClientId;
}

export async function startGoogleLogin() {
  try {
    const clientId = await getClientId();
    const redirectUri = window.location.origin + "/auth/google";
    const params = new URLSearchParams({
      client_id: clientId,
      redirect_uri: redirectUri,
      response_type: "code",
      scope: "openid email profile",
      access_type: "online",
      prompt: "select_account",
      include_granted_scopes: "true",
    });
    window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?${params.toString()}`;
  } catch (e) {
    toast.error(e?.message || "Google login non disponibile");
  }
}
